import { LucideIcon } from 'lucide-react';
import Link from 'next/link';

import { Button, Card, CardContent, Text } from '@/design-system/components/ui';

interface BaseProps {
  title: string;
  description: string;
  icon: LucideIcon;
  buttonText?: string;
}

interface LinkProps extends BaseProps {
  href: string;
  onClick?: never;
}

interface ButtonProps extends BaseProps {
  href?: never;
  onClick: () => void;
}

type Props = LinkProps | ButtonProps;

export const CreateFirstItemCard = ({ title, description, href, onClick, icon: Icon, buttonText = 'Start' }: Props) => {
  return (
    <Card>
      <CardContent>
        <div className="tw:flex tw:flex-col tw:items-center tw:text-center tw:gap-4 tw:py-8">
          <div className="tw:flex tw:items-center tw:justify-center tw:w-16 tw:h-16 tw:rounded-full tw:bg-[color:var(--color-primary-alpha8)] tw:text-[color:var(--color-primary-main)]">
            <Icon size={32} />
          </div>
          <Text variant="title-sm">{title}</Text>
          <Text variant="body-md" color="muted" className="tw:max-w-[400px]">
            {description}
          </Text>
          {href ? (
            <Button variant="primary" className="tw:mt-2" asChild>
              <Link href={href}>{buttonText}</Link>
            </Button>
          ) : (
            <Button variant="primary" className="tw:mt-2" onClick={onClick}>
              {buttonText}
            </Button>
          )}
        </div>
      </CardContent>
    </Card>
  );
};
